// import React from 'react';
// import { Controller, useFormContext } from 'react-hook-form';
// import ReactQuill from 'react-quill';
// import "./richEditorStyles.css"
// import 'react-quill/dist/quill.snow.css';

// export default function FormRichTextEditor({
//   name,
//   label,
//   placeholder,
//   validations = {},
//   disabled = false,
//   customValidations = {},
// }) {

//   const methods = useFormContext();
//   const { control } = methods;

//   const modules = {
//     toolbar: [
//       [{ header: [1, 2, 3, 4, 5, 6, false] }],
//       ['bold', 'italic', 'underline'],
//       [{ color: [] }],
//       [{ align: [] }],
//       [{ list: 'ordered' }, { list: 'bullet' }],
//       ['link', 'image', 'video'],
//       ['code-block'],
//       ['clean'],
//     ],
//   }

//   return (
//     <div className="flex flex-col space-y-4 mt-8">
//       {label && (
//         <label className="text-[18px] font-montserrat font-medium" htmlFor={name}>
//           {label}
//         </label>
//       )}

//       <Controller
//         name={name}
//         control={control}
//         rules={{
//           ...validations,
//           validate: Object.fromEntries(
//             Object.entries(customValidations).map(([key, fn]) => [
//               key,
//               fn.bind({
//                 form: methods,
//                 name,
//                 label,
//               }),
//             ])
//           ),
//         }}
//         render={({ field: { onChange, onBlur, value, ref } }) => (
//           <ReactQuill
//             theme="snow"
//             onChange={onChange}
//             modules={modules}
//             onBlur={onBlur}
//             value={value || ''}
//             readOnly={disabled}
//             placeholder={placeholder}
//             forwardedRef={ref}
//             className={`
//               rounded-[8px] border
//               ${disabled ? `
//                 border-gray-300 bg-gray-100 text-gray-500
//                 cursor-not-allowed pointer-events-none
//               ` : `
//                 border-[#999] hover:border-[#666] focus:border-blue-500
//                 focus:ring-1 focus:ring-blue-500
//               `}
//             `}
//           />
//         )}
//       />
//     </div>
//   );
// }


import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './richEditorStyles.css';

export default function FormRichTextEditor({
  name,
  label,
  placeholder,
  validations = {},
  disabled = false,
  customValidations = {},
}) {
  const methods = useFormContext();
  const { control } = methods;

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline'],
      [{ color: [] }],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image', 'video'],
      ['code-block'],
      ['clean'],
    ],
  };

  return (
    <div className="flex flex-col space-y-4 mt-8">
      {label && (
        <label
          className="text-[18px] font-montserrat font-medium"
          htmlFor={name}
        >
          {label}
        </label>
      )}

      <div
        className={`
    quill-wrapper
    ${disabled ? 'quill-wrapper-disabled' : ''}
    ${disabled ? `
      border-gray-300 bg-gray-100 text-gray-500
      cursor-not-allowed
    ` : `
      border-[#999] hover:border-[#666] focus-within:border-blue-500
      focus-within:ring-1 focus-within:ring-blue-500
    `}
  `}
      >
        <Controller
          name={name}
          control={control}
          rules={{
            ...validations,
            validate: Object.fromEntries(
              Object.entries(customValidations).map(([key, fn]) => [
                key,
                fn.bind({
                  form: methods,
                  name,
                  label,
                }),
              ])
            ),
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <ReactQuill
              theme="snow"
              modules={modules}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
              readOnly={disabled}
              placeholder={placeholder}
              forwardedRef={ref}
              className="bg-transparent"
            />
          )}
        />
      </div>
    </div>
  );
}
